import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {GroupActivity} from "../../models/groupActivity";
import {ReservationData} from "../../models/reservationData";
import {User} from "../../models";
import {map} from "rxjs/operators";
import {GroupActivityCustomer} from "../../models/GroupActivityCustomer";

@Injectable({ providedIn: 'root' })
export class GroupActivityService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getById(id: string) {
        return this.http.get<GroupActivity>(`${environment.apiEndpoint}/v1/group-activities/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    addParticipant(reservation: ReservationData, customer: User) {
        return this.http.post(`${environment.apiEndpoint}/v1/group-activities`, {
            groupActivity: reservation.groupActivity.id,
            customer: customer.id
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    deleteParticipant(id: string, groupActivityId: string) {
        return this.http.post(`${environment.apiEndpoint}/v1/group-activities/delete/${id}/${groupActivityId}`, {
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    markAsConfirmed(customer: GroupActivityCustomer) {
        return this.http.post(`${environment.apiEndpoint}/v1/group-activities/confirmed/${customer.id}`, {
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    markAsTookPartIn(customer: GroupActivityCustomer) {
        return this.http.post(`${environment.apiEndpoint}/v1/group-activities/took-part-in/${customer.id}`, {
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

}
